var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArvrDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 373,
    viewBox: "0 0 520 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2203_1589)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 512,
    height: 365,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.061 348.302C320.175 348.302 368.907 344.231 368.907 339.209C368.907 334.187 320.175 330.116 260.061 330.116C199.946 330.116 151.214 334.187 151.214 339.209C151.214 344.231 199.946 348.302 260.061 348.302Z",
    fill: "#EBF4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.128 271.271C187.761 271.271 187.76 274.943 190.128 274.943C192.494 274.943 192.495 271.271 190.128 271.271Z",
    fill: "#E8F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.813 352.328C263.447 352.328 263.446 356 265.813 356C268.18 356 268.181 352.328 265.813 352.328Z",
    fill: "#E8F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.195 262.97C351.828 262.97 351.827 266.642 354.195 266.642C356.56 266.642 356.562 262.97 354.195 262.97Z",
    fill: "#E8F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.86 183.866C407.494 183.866 407.493 187.538 409.86 187.538C412.226 187.538 412.227 183.866 409.86 183.866Z",
    fill: "#E8F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.627 217.558C125.26 217.558 125.259 221.23 127.627 221.23C129.993 221.23 129.994 217.558 127.627 217.558Z",
    fill: "#E8F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.841 204.616C94.5284 204.616 94.5269 209.757 97.841 209.757C101.154 209.758 101.155 204.616 97.841 204.616Z",
    fill: "#E8F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.211 243.68C391.898 243.68 391.897 248.821 395.211 248.821C398.524 248.822 398.525 243.68 395.211 243.68Z",
    fill: "#E8F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.698 303.047L357.348 299.143L358.045 303.038C358.262 304.247 359.216 305.19 360.427 305.391L364.331 306.041L360.436 306.739C359.227 306.956 358.284 307.909 358.083 309.12L357.433 313.024L356.735 309.129C356.518 307.92 355.565 306.978 354.353 306.777L350.45 306.127L354.345 305.429C355.554 305.213 356.497 304.259 356.698 303.047Z",
    fill: "#E6BC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.676 260.142L150.277 256.533L150.922 260.135C151.122 261.253 152.004 262.124 153.124 262.31L156.734 262.911L153.131 263.556C152.014 263.757 151.142 264.638 150.956 265.758L150.355 269.368L149.71 265.766C149.509 264.648 148.628 263.777 147.508 263.59L143.898 262.99L147.5 262.344C148.618 262.144 149.489 261.262 149.676 260.142Z",
    fill: "#E6BC7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M119.962 105.053L112.736 100.734L109.621 105.945C108.152 105.52 106.654 105.303 105.16 105.292L103.677 99.4026L95.5137 101.458L96.9967 107.348C95.686 108.066 94.4694 108.967 93.3771 110.038L88.1658 106.923L83.8466 114.149L89.0579 117.264C88.6323 118.733 88.4156 120.23 88.4034 121.725L82.5142 123.208L84.5698 131.371L90.4591 129.888C91.177 131.199 92.0778 132.415 93.1482 133.508L90.0335 138.719L97.2595 143.037L100.374 137.826C101.843 138.252 103.342 138.468 104.836 138.48L106.319 144.369L114.483 142.313L113 136.424C114.31 135.706 115.527 134.805 116.619 133.735L121.83 136.849L126.15 129.623L120.938 126.509C121.364 125.04 121.581 123.541 121.593 122.048L127.482 120.565L125.426 112.401L119.537 113.884C118.819 112.574 117.918 111.357 116.848 110.265L119.962 105.053ZM108.358 116.264C111.458 118.117 112.472 122.146 110.619 125.246C108.767 128.346 104.737 129.361 101.638 127.508C98.538 125.655 97.5232 121.626 99.3761 118.526C101.229 115.426 105.258 114.412 108.358 116.264Z",
    fill: "url(#paint0_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M359.179 33.6415L351.621 32.6233L350.886 38.0739C349.511 38.2436 348.187 38.5987 346.938 39.1218L343.601 34.7459L337.536 39.3707L340.873 43.7465C340.038 44.8117 339.345 45.9962 338.818 47.2773L333.366 46.5427L332.348 54.1012L337.8 54.8357C337.969 56.2108 338.324 57.5354 338.847 58.7843L334.471 62.1209L339.096 68.186L343.471 64.8493C344.537 65.6839 345.721 66.3767 347.002 66.9041L346.268 72.3556L353.826 73.3738L354.561 67.9232C355.936 67.7535 357.26 67.3993 358.509 66.8762L361.846 71.252L367.911 66.6273L364.575 62.2515C365.41 61.1863 366.102 60.0018 366.63 58.7207L372.081 59.4552L373.1 51.8968L367.648 51.1622C367.478 49.7872 367.124 48.4617 366.601 47.2137L370.977 43.877L366.352 37.8128L361.977 41.1487C360.911 40.3132 359.728 39.6213 358.446 39.0939L359.179 33.6415ZM353.752 45.367C357.96 45.9335 360.922 49.8185 360.355 54.0264C359.788 58.2342 355.903 61.1967 351.696 60.6293C347.489 60.0627 344.526 56.1777 345.094 51.9699C345.659 47.762 349.544 44.8004 353.752 45.367Z",
    fill: "url(#paint1_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.962 43.136V105.454C214.952 103.626 230.132 102.626 245.986 102.626C269.691 102.626 291.875 104.854 310.877 108.747V46.4196C291.876 42.5355 269.691 40.3066 245.986 40.3066C230.132 40.3075 214.951 41.3075 200.962 43.136Z",
    fill: "url(#paint2_linear_2203_1589)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.141 47.0781C234.808 47.1547 221.774 47.9693 209.324 49.5002C208.657 49.582 208.165 50.1538 208.169 50.8265C208.169 50.8361 208.169 50.8448 208.169 50.8543C208.175 51.6454 208.856 52.2512 209.641 52.1546C221.992 50.6359 234.928 49.8291 248.163 49.7534C248.884 49.7491 249.47 49.1703 249.477 48.4489C249.477 48.4393 249.477 48.4297 249.477 48.4201C249.483 47.6795 248.881 47.0738 248.141 47.0781Z",
    fill: "url(#paint3_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.083 52.9988C234.772 53.078 221.758 53.8917 209.326 55.42C208.662 55.5018 208.166 56.0701 208.166 56.7402C208.166 56.7489 208.166 56.7585 208.166 56.768C208.166 57.5617 208.856 58.1709 209.643 58.0743C221.976 56.5583 234.891 55.7524 248.104 55.6741C248.826 55.6697 249.41 55.091 249.418 54.3695C249.418 54.3599 249.418 54.3504 249.418 54.3408C249.427 53.6002 248.823 52.9945 248.083 52.9988Z",
    fill: "url(#paint4_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.042 58.9195C234.746 58.9995 221.748 59.8132 209.331 61.3389C208.666 61.4207 208.17 61.989 208.17 62.6591C208.17 62.6687 208.17 62.6774 208.17 62.6869C208.171 63.4807 208.861 64.0907 209.648 63.9933C221.966 62.479 234.867 61.6739 248.064 61.5939C248.789 61.5895 249.376 61.0055 249.378 60.2806C249.378 60.271 249.378 60.2614 249.378 60.2519C249.38 59.5156 248.779 58.9151 248.042 58.9195Z",
    fill: "url(#paint5_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.55 65.9272C218.084 66.2849 213.674 66.727 209.338 67.2596C208.673 67.3414 208.176 67.9097 208.177 68.5799C208.177 68.5894 208.177 68.5981 208.177 68.6077C208.178 69.4014 208.867 70.0106 209.655 69.914C213.958 69.3858 218.334 68.9471 222.767 68.5921C223.449 68.5372 223.98 67.9741 223.986 67.2901C223.986 67.2814 223.986 67.2718 223.986 67.2631C223.993 66.4851 223.326 65.8646 222.55 65.9272Z",
    fill: "url(#paint6_linear_2203_1589)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.198 74.9441C276.531 75.0216 289.565 75.8353 302.015 77.3661C302.682 77.4479 303.174 78.0197 303.17 78.6925C303.17 78.702 303.17 78.7107 303.17 78.7203C303.165 79.5114 302.483 80.1171 301.698 80.0205C289.347 78.5019 276.411 77.6951 263.176 77.6194C262.455 77.615 261.869 77.0363 261.862 76.3148C261.862 76.3053 261.862 76.2957 261.862 76.2861C261.856 75.5455 262.459 74.9398 263.198 74.9441Z",
    fill: "url(#paint7_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.257 80.8657C276.568 80.9449 289.582 81.7587 302.013 83.2869C302.678 83.3687 303.174 83.937 303.174 84.6071C303.174 84.6158 303.174 84.6254 303.174 84.635C303.174 85.4287 302.484 86.0379 301.696 85.9413C289.364 84.4252 276.448 83.6194 263.236 83.541C262.514 83.5367 261.929 82.9571 261.921 82.2365C261.921 82.2269 261.921 82.2173 261.921 82.2077C261.913 81.4671 262.517 80.8614 263.257 80.8657Z",
    fill: "url(#paint8_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.297 86.7859C276.592 86.866 289.59 87.6797 302.007 89.2053C302.672 89.2871 303.169 89.8554 303.168 90.5256C303.168 90.5351 303.168 90.5438 303.168 90.5534C303.167 91.3471 302.478 91.9572 301.691 91.8597C289.373 90.3454 276.472 89.5404 263.275 89.4603C262.55 89.456 261.963 88.872 261.961 88.1471C261.961 88.1375 261.961 88.1279 261.961 88.1183C261.959 87.3821 262.56 86.7807 263.297 86.7859Z",
    fill: "url(#paint9_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.789 93.7931C293.256 94.1508 297.666 94.5929 302.001 95.1255C302.666 95.2073 303.163 95.7756 303.162 96.4457C303.162 96.4544 303.162 96.464 303.162 96.4736C303.161 97.2673 302.472 97.8765 301.685 97.7799C297.381 97.2516 293.005 96.813 288.572 96.4579C287.89 96.4031 287.36 95.84 287.353 95.1559C287.353 95.1472 287.353 95.1385 287.353 95.129C287.346 94.3509 288.013 93.7313 288.789 93.7931Z",
    fill: "url(#paint10_linear_2203_1589)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M326.729 84.948V146.31C328.033 146.434 329.312 146.567 330.575 146.708C335.752 147.248 340.596 147.83 345.133 148.461C347.983 148.843 350.7 149.25 353.309 149.674C360.737 150.871 367.194 152.183 372.777 153.596C395.236 159.271 403.496 166.574 403.496 174.534V113.164C403.495 101.159 384.709 90.6484 326.729 84.948Z",
    fill: "url(#paint11_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.399 97.9312C335.399 98.9007 336.139 99.7109 337.103 99.8093C387.2 104.91 403.496 114.145 403.496 124.677V120.874C403.496 110.369 387.281 101.153 337.48 96.0522C336.368 95.9382 335.399 96.8137 335.399 97.9312Z",
    fill: "url(#paint12_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.399 105.59C335.399 106.559 336.139 107.37 337.103 107.468C387.2 112.569 403.496 121.803 403.496 132.335V128.532C403.496 118.026 387.281 108.812 337.48 103.71C336.368 103.596 335.399 104.471 335.399 105.59Z",
    fill: "url(#paint13_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.399 113.247C335.399 114.217 336.139 115.027 337.103 115.125C387.2 120.226 403.496 129.461 403.496 139.992V136.189C403.496 125.684 387.281 116.469 337.48 111.368C336.368 111.254 335.399 112.13 335.399 113.247Z",
    fill: "url(#paint14_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.399 120.906C335.399 121.875 336.139 122.687 337.103 122.784C387.2 127.885 403.496 137.119 403.496 147.652V143.849C403.496 133.343 387.281 124.129 337.48 119.027C336.368 118.912 335.399 119.788 335.399 120.906Z",
    fill: "url(#paint15_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.399 128.564C335.399 129.533 336.139 130.344 337.103 130.442C387.2 135.542 403.496 144.777 403.496 155.309V151.506C403.496 141.001 387.281 131.785 337.48 126.685C336.368 126.571 335.399 127.446 335.399 128.564Z",
    fill: "url(#paint16_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.143 142.179C373.129 140.981 374.255 140.095 375.419 140.382C395.967 145.449 403.496 152.007 403.496 159.164V162.967C403.496 155.71 395.758 149.069 374.555 143.971C373.739 143.776 373.155 143.055 373.144 142.216C373.143 142.204 373.143 142.192 373.143 142.179Z",
    fill: "url(#paint17_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.798 131.854V193.224C397.328 187.957 403.495 181.57 403.495 174.687V113.317C403.495 120.193 397.328 126.578 386.798 131.854Z",
    fill: "#D9D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.684 49.2685C320.448 50.1614 320.158 51.0665 319.805 51.9917C316.606 60.4065 309.941 64.798 302.75 65.8728C289.412 67.8945 274.258 58.5528 276.002 42.4089C276.169 40.858 276.51 39.3324 277.022 37.8677C279.05 31.9105 283.66 26.8272 289.492 24.4147C292.508 23.1746 295.664 22.581 298.764 22.5723C312.322 22.5453 324.884 33.5737 320.684 49.2685Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.763 22.574C298.702 22.7533 298.649 22.9326 298.605 23.1136C298.123 25.0039 298.212 26.9142 298.954 28.7192C299.609 30.3231 300.786 31.6164 301.703 33.0689C302.246 33.9139 302.965 35.2246 302.267 36.1602C301.62 37.0217 300.064 37.7258 299.202 38.6283C296.706 41.2392 296.835 45.1868 298.923 47.9944C301.214 51.0769 305.317 51.7897 308.92 51.3981C312.416 51.023 315.688 49.3137 319.223 49.1797C319.691 49.1632 320.19 49.1849 320.684 49.2676C324.884 33.5736 312.322 22.5453 298.763 22.574ZM297.853 56.7025C296.722 56.1003 295.548 55.5911 294.397 55.022C293.968 54.8131 293.7 54.673 293.194 54.351C292.995 54.2257 292.796 54.0925 292.607 53.9507C292.509 53.8793 292.185 53.5843 292.134 53.5616C292.126 53.5521 292.126 53.5521 292.126 53.5521C291.509 52.9202 291.193 52.3702 291.225 51.3084C291.268 50.0361 291.844 48.8064 292.308 47.6541C293.347 45.0963 294.409 42.2148 293.119 39.5282C291.829 36.8416 288.779 35.6145 285.925 35.6293C282.764 35.6493 280.019 37.1714 277.02 37.8677C276.51 39.3324 276.168 40.858 276 42.4088C274.256 58.5519 289.411 67.8945 302.749 65.8728C302.901 64.7518 302.967 63.6135 302.74 62.5004C302.202 59.7903 300.215 57.9522 297.853 56.7025Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.929 48.2799C320.853 48.6071 320.768 48.9335 320.683 49.2685C320.447 50.1614 320.157 51.0665 319.804 51.9917C316.606 60.4065 309.94 64.798 302.75 65.8728C289.412 67.8945 274.257 58.5528 276.001 42.4089C276.169 40.858 276.51 39.3324 277.021 37.8677C277.561 36.2916 278.281 34.7677 279.166 33.3474C279.062 33.8739 278.984 34.4127 278.923 34.9522C277.179 51.0953 292.333 60.4378 305.671 58.4162C311.709 57.5128 317.374 54.2744 320.929 48.2799Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.91 28.6799C332.626 30.0254 331.74 31.1811 330.914 32.2559C328.229 35.7832 324.982 38.7996 321.435 41.4497C317.967 44.0423 314.232 46.2737 310.447 48.3006C301.775 52.9436 292.707 56.8773 283.418 60.1105C283.247 60.167 283.078 60.2323 282.907 60.2889C280.822 61.0138 278.725 61.6979 276.617 62.3419C274.215 63.0782 271.639 64.1216 269.099 63.9337C266.903 63.7657 264.752 62.2984 264.346 60.0435C263.928 57.7398 265.446 55.7929 266.977 54.2726C269.762 51.5137 272.74 48.9472 275.933 46.654C276.016 47.7001 276.18 48.714 276.399 49.6896C273.704 51.9471 271.09 54.3735 268.832 57.0357C267.983 58.0374 266.955 59.6649 268.732 60.2958C270.458 60.9225 272.745 59.8294 274.398 59.3333C276.335 58.738 278.271 58.1184 280.187 57.4665C282.452 56.7007 284.704 55.8861 286.937 55.0393C294.897 51.9967 302.741 48.4956 310.165 44.2964C313.813 42.2312 317.365 39.9241 320.591 37.2436C323.241 35.0478 325.677 32.5962 327.776 29.8295C328.248 29.2029 328.687 28.5885 328.986 27.8853C328.978 27.8862 328.978 27.8862 328.969 27.8871C328.766 27.8627 328.617 27.7844 328.321 27.7513C326.484 27.5772 324.222 28.0837 322.336 28.4066C320.243 28.7565 318.158 29.1968 316.099 29.7364C315.067 28.6312 313.894 27.6469 312.632 26.787C316.58 25.3815 320.659 24.4233 324.856 23.9577C327.074 23.7053 329.804 23.2919 331.663 24.8602C332.766 25.7923 333.206 27.2839 332.91 28.6799Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.375 15.2508C304.007 16.8208 305.84 17.9331 307.649 17.8164C309.457 17.6998 311.067 16.3422 311.312 14.6973C311.603 12.7331 309.512 9.91244 307.186 10.0021C304.362 10.11 302.382 12.7844 303.375 15.2508Z",
    fill: "#E47272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.671 81.9682C278.845 83.6087 282.029 83.7697 284.357 82.3555C289.997 78.9309 287.352 70.1714 281.051 69.691C274.503 69.1924 271.522 78.0833 276.671 81.9682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.099 75.8481L381.481 81.1421L377.904 64.2158L361.458 58.8496L365.099 75.8481Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.481 81.1414L394.32 69.6736L390.679 52.675L377.904 64.216L381.481 81.1414Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.458 58.8496L377.904 64.215L390.679 52.6749L374.232 47.3096L361.458 58.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.457 84.9574V66.6047",
    stroke: "#8484FD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.457 86.854V89.4884",
    stroke: "#8484FD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.03 81.3137V72.3306",
    stroke: "#8484FD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M344.525 176.865V154.418C355.055 159.686 361.222 166.072 361.222 172.955V195.402C361.222 188.526 355.055 182.14 344.525 176.865Z",
    fill: "url(#paint18_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.504 194.045C326.371 195.09 321.758 196.081 316.628 197.011C316.651 204.489 316.674 211.967 316.695 219.445C349.659 213.468 361.222 204.972 361.222 195.553V173.107C361.223 181.066 352.964 188.37 330.504 194.045Z",
    fill: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M349.36 165.547C349.36 165.563 349.361 165.58 349.361 165.595C349.37 166.19 349.682 166.737 350.181 167.061C357.221 171.633 361.222 176.844 361.222 182.375V178.016C361.222 173.032 357.979 168.311 352.194 164.085C351.008 163.218 349.337 164.078 349.36 165.547Z",
    fill: "url(#paint19_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M349.422 172.984C349.422 172.999 349.422 173.013 349.422 173.028C349.427 173.627 349.74 174.181 350.243 174.508C357.245 179.071 361.223 184.268 361.223 189.782V185.423C361.223 180.458 358.004 175.754 352.262 171.54C351.081 170.675 349.413 171.521 349.422 172.984Z",
    fill: "url(#paint20_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.764 168.812C351.764 168.812 364.351 159.678 381.21 152.282L355.227 113.624L331.853 134.496C331.853 134.496 311.999 144.774 295.548 138.819L293.701 144.706L318.587 180.779C318.587 180.779 338.563 180.499 351.764 168.812Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.717 132.482L349.839 166.369C349.839 166.369 335.009 178.63 319.448 175.41L296.105 137.042C317.32 141.683 317.57 125.506 330.717 132.482Z",
    fill: "#F5F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.717 132.482C329.805 121.595 349.839 110.547 349.839 110.547L375.767 149.88C375.767 149.88 360.151 150.598 349.839 166.37L330.717 132.482Z",
    fill: "#F5F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.717 132.482L349.84 166.369",
    stroke: "#5186C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.686 144.472C315.757 142.736 314.857 140.962 313.761 139.325C313.639 139.143 313.375 138.97 313.142 139.064C310.941 139.955 308.626 140.517 306.358 141.219C306.122 141.169 305.865 141.28 305.708 141.473C305.364 141.766 305.471 142.35 305.833 142.526C306.37 143.567 306.908 144.608 307.446 145.649C307.738 146.213 308.02 146.786 308.336 147.337C308.591 147.782 308.932 148.201 309.454 148.317C310.006 148.441 310.597 148.186 311.09 147.968C311.681 147.708 312.258 147.416 312.838 147.134C314.03 146.554 315.224 145.984 316.425 145.424C316.771 145.261 316.852 144.783 316.686 144.472ZM312.727 145.763C312.238 146.01 311.748 146.257 311.259 146.504C311 146.635 310.744 146.77 310.489 146.909C310.312 147.005 310.048 147.202 309.844 147.166C309.484 147.101 309.286 146.419 309.15 146.149C308.9 145.652 308.638 145.159 308.38 144.665C307.959 143.859 307.537 143.051 307.115 142.244C309.061 141.557 310.987 140.8 312.978 140.258C313.613 141.715 314.371 143.123 315.128 144.524C314.329 144.94 313.531 145.357 312.727 145.763Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.585 133.883C323.853 132.693 321.058 136.448 317.747 137.28C317.153 137.429 317.394 138.322 317.987 138.195C319.629 137.843 321.027 136.911 322.474 136.109C323.947 135.293 325.556 134.67 327.227 135.248C328.08 135.543 328.453 134.16 327.585 133.883Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.673 137.434C327.909 137.358 327.08 137.477 326.324 137.587C325.537 137.701 324.763 137.897 324.017 138.169C322.517 138.716 321.155 139.53 319.974 140.604C319.424 141.104 320.226 141.879 320.782 141.413C321.863 140.507 323.131 139.809 324.475 139.382C325.133 139.173 325.812 139.017 326.498 138.935C327.234 138.847 327.937 138.911 328.673 138.928C329.076 138.937 329.419 138.578 329.419 138.181C329.419 137.745 329.076 137.475 328.673 137.434Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.297 142.409C323.98 143.122 318.58 148.799 311.601 150.513C310.876 150.691 311.172 151.774 311.893 151.627C315.363 150.915 318.477 149.209 321.575 147.564C324.625 145.944 327.796 144.317 331.297 144.033C332.338 143.949 332.333 142.308 331.297 142.409Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.59 151.115C320.009 151.252 319.483 151.555 318.94 151.793C318.462 152.001 317.974 152.187 317.477 152.348C316.429 152.687 315.329 152.936 314.233 153.069C313.916 153.108 313.642 153.314 313.642 153.66C313.642 153.969 313.913 154.264 314.233 154.251C315.453 154.2 316.65 154.008 317.821 153.661C318.399 153.49 318.964 153.283 319.517 153.047C320.101 152.797 320.689 152.532 321.14 152.073C321.542 151.662 321.14 150.985 320.59 151.115Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.723 156.532C339.847 153.538 337.791 149.9 334.208 150.053C332.137 150.142 330.334 151.339 328.66 152.443C326.915 153.592 325.108 154.646 323.242 155.589C321.101 156.671 318.91 157.671 316.667 158.529C316.329 158.658 316.247 159.005 316.345 159.265C315.842 159.249 315.359 159.719 315.679 160.305C316.541 161.884 317.581 163.381 318.546 164.901C318.759 165.237 319.204 165.397 319.566 165.182C322.71 163.316 326.009 161.715 329.431 160.425C331.137 159.782 332.871 159.211 334.625 158.716C336.373 158.222 338.173 157.724 339.979 157.496C340.448 157.437 340.876 157.056 340.723 156.532ZM334.259 157.323C332.468 157.824 330.699 158.403 328.959 159.058C325.678 160.293 322.504 161.795 319.458 163.531C318.646 162.202 317.851 160.85 316.946 159.587C316.936 159.574 316.924 159.569 316.915 159.556C316.922 159.555 316.929 159.556 316.937 159.554C320.663 158.457 324.202 156.904 327.555 154.944C330.146 153.429 334.056 149.867 336.924 152.716C337.9 153.684 338.419 154.935 338.927 156.183C337.368 156.556 335.803 156.891 334.259 157.323Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.685 158.881C338.106 159.326 336.557 160.022 335.014 160.586C333.457 161.155 331.901 161.724 330.344 162.293C327.228 163.434 324.125 164.608 321.031 165.809C320.3 166.092 320.581 167.275 321.347 167.01C324.516 165.918 327.676 164.799 330.824 163.645C332.38 163.074 333.936 162.504 335.493 161.933C337.057 161.36 338.704 160.88 340.219 160.191C340.96 159.853 340.45 158.666 339.685 158.881Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.577 166.068C330.188 166.035 329.816 166.253 329.476 166.423C329.196 166.563 328.914 166.698 328.629 166.827C328.055 167.087 327.473 167.324 326.88 167.536C325.636 167.98 324.356 168.316 323.056 168.548C322.71 168.61 322.507 169.022 322.591 169.344C322.689 169.719 323.037 169.858 323.387 169.81C324.74 169.622 326.075 169.323 327.377 168.905C328.036 168.693 328.683 168.45 329.32 168.182C329.931 167.925 330.809 167.666 331.153 167.06C331.416 166.598 331.063 166.107 330.577 166.068Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.155 117.611C346.395 117.631 345.59 118.165 344.928 118.512C344.262 118.861 343.612 119.241 342.979 119.648C341.636 120.513 340.366 121.5 339.198 122.588C336.884 124.743 334.978 127.335 333.587 130.173C333.251 130.859 334.273 131.455 334.628 130.764C336.015 128.073 337.868 125.669 340.093 123.617C341.202 122.595 342.399 121.676 343.673 120.87C344.283 120.485 344.908 120.126 345.548 119.794C346.2 119.456 347.083 119.222 347.609 118.708C348.004 118.327 347.714 117.596 347.155 117.611Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.334 127.454C340.184 127.304 339.904 127.246 339.721 127.37C339.251 127.69 338.903 128.092 338.539 128.522C338.178 128.946 337.834 129.382 337.485 129.816C336.796 130.67 336.108 131.525 335.42 132.379C335.224 132.622 335.182 132.96 335.42 133.199C335.629 133.407 336.035 133.437 336.239 133.199C336.953 132.37 337.667 131.541 338.381 130.712C338.733 130.304 339.09 129.899 339.431 129.482C339.798 129.034 340.181 128.601 340.418 128.067C340.51 127.858 340.505 127.624 340.334 127.454Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.846 129.699C356.935 128.07 355.862 126.29 354.07 125.525C352.029 124.654 349.893 125.503 348.075 126.51C346.225 127.535 344.481 128.761 342.865 130.125C341.227 131.508 339.624 133.095 338.438 134.892C338.41 134.934 338.399 134.977 338.386 135.02C337.868 135.006 337.338 135.591 337.684 136.123C338.808 137.853 340.208 139.439 341.469 141.073C341.734 141.415 342.261 141.308 342.54 141.073C347.197 137.129 352.235 133.658 357.571 130.697C357.918 130.504 358.038 130.042 357.846 129.699ZM339.152 135.592C339.189 135.571 339.227 135.552 339.26 135.518C340.606 134.142 341.889 132.741 343.351 131.482C344.785 130.246 346.331 129.147 347.966 128.192C349.51 127.289 351.533 126.045 353.378 126.76C354.699 127.271 355.54 128.565 356.223 129.788C351.247 132.585 346.537 135.827 342.137 139.464C341.164 138.162 340.213 136.819 339.152 135.592Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.171 132.589C358.664 132.365 358.258 132.605 357.781 132.808C357.365 132.984 356.956 133.175 356.554 133.38C355.728 133.801 354.931 134.279 354.172 134.812C352.653 135.876 351.306 137.13 350.145 138.575C349.7 139.13 350.456 139.927 350.943 139.373C352.081 138.077 353.386 136.912 354.815 135.944C355.526 135.463 356.268 135.028 357.036 134.642C357.419 134.45 357.81 134.269 358.206 134.103C358.621 133.929 359.187 133.84 359.394 133.401C359.522 133.132 359.483 132.728 359.171 132.589Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.141 135.647C360.985 135.442 360.761 135.389 360.515 135.427C360.318 135.457 360.144 135.595 359.977 135.699C359.85 135.777 359.723 135.856 359.596 135.935C359.333 136.099 359.074 136.269 358.814 136.436C358.282 136.777 357.752 137.117 357.238 137.485C357.018 137.642 356.882 137.937 357.043 138.192C357.198 138.439 357.491 138.518 357.749 138.387C358.321 138.096 358.874 137.776 359.429 137.457C359.707 137.298 359.985 137.141 360.26 136.977C360.388 136.9 360.517 136.823 360.645 136.747C360.718 136.703 360.793 136.662 360.865 136.615C361.005 136.527 361.091 136.435 361.188 136.302C361.326 136.116 361.269 135.816 361.141 135.647Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.279 139.473C361.535 139.495 360.753 139.938 360.073 140.226C359.4 140.512 358.736 140.819 358.082 141.147C356.686 141.849 355.338 142.647 354.05 143.531C351.503 145.279 349.217 147.378 347.234 149.746C346.774 150.295 347.547 151.093 348.032 150.544C350 148.317 352.245 146.354 354.709 144.693C355.922 143.875 357.187 143.134 358.494 142.477C359.148 142.148 359.812 141.841 360.485 141.554C361.147 141.273 362.027 141.108 362.597 140.676C363.063 140.324 362.993 139.45 362.279 139.473Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.151 141.257C348.376 140.279 347.058 139.909 345.884 140.332C344.458 140.844 343.62 142.176 343.322 143.61C343.274 143.843 343.369 144.023 343.516 144.132C343.923 145.356 345.016 146.187 346.294 146.338C347.539 146.486 348.742 145.826 349.401 144.781C350.103 143.667 349.954 142.269 349.151 141.257ZM348.341 143.181C348.341 143.19 348.337 143.238 348.335 143.268C348.33 143.297 348.322 143.344 348.319 143.353C348.309 143.401 348.297 143.449 348.284 143.496C348.27 143.543 348.255 143.589 348.238 143.636C348.234 143.649 348.235 143.65 348.235 143.652C348.231 143.659 348.226 143.664 348.215 143.685C348.16 143.781 348.111 143.878 348.049 143.97C348.043 143.98 348.015 144.016 347.997 144.039C347.979 144.06 347.957 144.084 347.951 144.091C347.885 144.164 347.815 144.233 347.741 144.299C347.733 144.306 347.706 144.329 347.684 144.347C347.651 144.369 347.573 144.425 347.558 144.434C347.475 144.487 347.39 144.537 347.301 144.58C347.292 144.585 347.257 144.6 347.231 144.613C347.204 144.623 347.165 144.637 347.156 144.64C347.062 144.671 346.967 144.692 346.87 144.714C346.858 144.716 346.862 144.716 346.855 144.718C346.781 144.724 346.707 144.727 346.632 144.727C346.581 144.727 346.532 144.723 346.481 144.72C346.463 144.72 346.46 144.72 346.46 144.722C346.452 144.72 346.449 144.72 346.428 144.715C346.305 144.69 346.185 144.658 346.064 144.622C346.055 144.62 346.034 144.612 346.016 144.605C345.958 144.579 345.902 144.553 345.847 144.524C345.747 144.471 345.648 144.413 345.553 144.351C345.546 144.346 345.518 144.328 345.494 144.311C345.467 144.289 345.405 144.24 345.395 144.231C345.3 144.148 345.214 144.056 345.13 143.962C345.097 143.925 345.064 143.887 345.031 143.849C345.025 143.842 344.967 143.764 344.951 143.745C344.889 143.65 344.83 143.554 344.778 143.453C344.721 143.344 344.644 143.27 344.559 143.212C344.825 142.604 345.226 142.059 345.824 141.736C346.186 141.54 346.606 141.432 347.016 141.493C347.061 141.5 347.166 141.528 347.233 141.548C347.374 141.591 347.332 141.577 347.44 141.635C347.652 141.748 347.669 141.757 347.846 141.937C347.881 141.972 347.912 142.01 347.946 142.045C347.966 142.067 347.969 142.068 347.978 142.077C347.98 142.081 347.976 142.079 347.988 142.095C348.044 142.175 348.096 142.259 348.143 142.346C348.166 142.39 348.188 142.434 348.209 142.479C348.216 142.493 348.215 142.491 348.218 142.496C348.22 142.501 348.218 142.499 348.222 142.506C348.259 142.61 348.291 142.716 348.314 142.825C348.311 142.815 348.327 142.92 348.334 142.956C348.336 142.985 348.338 143.028 348.338 143.036C348.344 143.083 348.344 143.132 348.341 143.181Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.548 149.112C353.372 148.881 352.972 148.742 352.712 148.936C351.502 149.841 350.41 150.907 349.288 151.915C349.048 152.13 349.052 152.568 349.288 152.783C349.553 153.026 349.889 153.002 350.155 152.783C350.718 152.32 351.282 151.857 351.845 151.394C352.408 150.932 352.975 150.476 353.495 149.964C353.726 149.737 353.741 149.365 353.548 149.112Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.018 144.899C364.609 145.363 363.238 146.063 361.928 146.753C360.57 147.469 359.252 148.261 357.987 149.129C355.487 150.847 353.211 152.868 351.184 155.122C350.689 155.673 351.478 156.478 352.004 155.941C354.064 153.838 356.342 151.969 358.793 150.34C359.986 149.547 361.22 148.817 362.491 148.155C363.829 147.46 365.222 146.922 366.59 146.298C367.372 145.941 366.836 144.629 366.018 144.899Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M191.335 59.0359V120.398C190.03 120.522 188.751 120.655 187.488 120.796C182.312 121.337 177.468 121.918 172.931 122.55C170.081 122.932 167.364 123.339 164.755 123.763C157.327 124.96 150.87 126.272 145.287 127.684C122.828 133.36 114.568 140.663 114.568 148.623V87.2525C114.568 75.2468 133.354 64.7354 191.335 59.0359Z",
    fill: "url(#paint21_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.665 72.019C182.665 72.9885 181.925 73.7987 180.961 73.8971C130.865 78.9978 114.568 88.2325 114.568 98.7639V94.9607C114.568 84.4554 130.783 75.2399 180.585 70.1391C181.697 70.0251 182.665 70.9007 182.665 72.019Z",
    fill: "url(#paint22_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.665 79.6766C182.665 80.6461 181.925 81.4572 180.961 81.5546C130.865 86.6554 114.568 95.8901 114.568 106.421V102.618C114.568 92.113 130.783 82.8984 180.585 77.7967C181.697 77.6836 182.665 78.5591 182.665 79.6766Z",
    fill: "url(#paint23_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.665 87.3354C182.665 88.3049 181.925 89.1151 180.961 89.2135C130.865 94.3143 114.568 103.549 114.568 114.08V110.277C114.568 99.7718 130.783 90.5572 180.585 85.4556C181.697 85.3415 182.665 86.2171 182.665 87.3354Z",
    fill: "url(#paint24_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.665 94.9927C182.665 95.9622 181.925 96.7725 180.961 96.8708C130.865 101.972 114.568 111.206 114.568 121.739V117.935C114.568 107.43 130.783 98.2154 180.585 93.1138C181.697 92.9998 182.665 93.8753 182.665 94.9927Z",
    fill: "url(#paint25_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.665 102.652C182.665 103.621 181.925 104.431 180.961 104.53C130.865 109.63 114.568 118.865 114.568 129.397V125.594C114.568 115.089 130.783 105.873 180.585 100.773C181.697 100.658 182.665 101.533 182.665 102.652Z",
    fill: "url(#paint26_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.921 116.266C144.935 115.068 143.808 114.182 142.646 114.469C122.098 119.536 114.568 126.094 114.568 133.252V137.055C114.568 129.798 122.307 123.156 143.51 118.059C144.325 117.863 144.911 117.143 144.921 116.304C144.921 116.292 144.921 116.279 144.921 116.266Z",
    fill: "url(#paint27_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.266 105.941V167.312C120.736 162.044 114.568 155.658 114.568 148.774V87.4041C114.569 94.2802 120.737 100.666 131.266 105.941Z",
    fill: "#D9D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.74 107.614C244.082 102.8 242.078 96.9992 237.264 94.657C232.45 92.3149 226.649 94.3186 224.307 99.1324C221.965 103.946 223.969 109.747 228.783 112.089C233.596 114.432 239.398 112.428 241.74 107.614Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.355 106.885C222.895 112.012 219.987 117.417 214.86 118.957C209.733 120.497 204.328 117.588 202.787 112.461C201.248 107.334 204.155 101.928 209.283 100.388C214.411 98.8493 219.815 101.757 221.355 106.885Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.145 76.956L190.899 92.3479C185.236 94.0485 182.025 100.018 183.725 105.681L185.31 110.957C187.079 116.847 193.287 120.187 199.176 118.418L249.602 103.273C255.491 101.503 258.831 95.2956 257.063 89.4064L255.478 84.1298C253.778 78.4668 247.808 75.2554 242.145 76.956Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.393 72.9492L189.319 88.5892C183.885 90.221 180.802 95.9501 182.435 101.384L183.925 106.348C185.558 111.782 191.286 114.865 196.721 113.232L248.794 97.5924C254.229 95.9606 257.311 90.2314 255.678 84.7973L254.188 79.8332C252.556 74.4 246.828 71.3174 241.393 72.9492Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.685 104.875C219.817 108.643 217.68 112.616 213.911 113.747C210.143 114.88 206.17 112.742 205.039 108.974C203.906 105.205 206.044 101.233 209.812 100.101C213.58 98.9681 217.552 101.105 218.685 104.875Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.222 99.0067C239.353 102.775 237.217 106.748 233.447 107.879C229.679 109.012 225.706 106.874 224.575 103.106C223.443 99.3374 225.58 95.3645 229.349 94.2331C233.118 93.1009 237.09 95.2383 238.222 99.0067Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.789 99.3894C236.509 101.786 235.15 104.314 232.753 105.033C230.356 105.753 227.829 104.394 227.109 101.997C226.389 99.6 227.749 97.0727 230.146 96.3529C232.542 95.6323 235.07 96.9917 235.789 99.3894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.303 105.242C217.023 107.639 215.663 110.166 213.267 110.886C210.87 111.606 208.343 110.246 207.623 107.85C206.903 105.453 208.262 102.925 210.659 102.206C213.056 101.485 215.583 102.845 216.303 105.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.308 101.596C204.519 107.011 199.488 110.761 194.073 109.971C188.658 109.182 184.908 104.152 185.698 98.7367C186.487 93.3218 191.516 89.5717 196.932 90.361C202.347 91.1504 206.097 96.1798 205.308 101.596Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.564 87.4022C251.774 92.8172 246.744 96.5673 241.329 95.7779C235.914 94.9886 232.164 89.9583 232.954 84.5433C233.743 79.1284 238.772 75.3783 244.188 76.1677C249.603 76.957 253.353 81.9873 252.564 87.4022Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.809 92.8275L210.322 98.3799C209.031 98.7672 207.67 98.0353 207.282 96.7447L204.1 86.1506C203.713 84.86 204.445 83.4988 205.735 83.1107L224.222 77.5582C225.513 77.1709 226.874 77.9028 227.262 79.1935L230.444 89.7875C230.832 91.0791 230.1 92.4393 228.809 92.8275Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.038 91.0078L209.964 96.4367C208.559 96.8588 207.078 96.0616 206.656 94.6569L203.697 84.8079C203.275 83.4032 204.073 81.922 205.477 81.4999L223.551 76.071C224.956 75.6489 226.437 76.4461 226.859 77.8507L229.818 87.6998C230.24 89.1045 229.442 90.5857 228.038 91.0078Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.286 79.574L226.53 87.0454C226.831 88.0445 226.265 89.101 225.262 89.4022L211.591 93.5082C211.27 93.6048 210.942 93.61 210.633 93.5386C209.991 93.3977 209.437 92.9181 209.234 92.2402L206.99 84.7687C206.822 84.2109 207.139 83.6234 207.697 83.4555L222.973 78.8673C223.531 78.6993 224.119 79.0161 224.286 79.574Z",
    fill: "#D9DADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.628 79.2712L218.477 91.4405L211.928 93.4074L215.079 81.2381L221.628 79.2712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.712 81.6487L210.633 93.5386C209.991 93.3976 209.437 92.9181 209.234 92.2401L208.322 89.2037L209.986 82.767L213.712 81.6487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.537 80.4114L225.6 83.9474L224.096 89.7522L221.955 90.3962L224.537 80.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.651 98.5088C217.76 98.87 217.554 99.2503 217.194 99.3591C216.833 99.4679 216.452 99.2625 216.344 98.9022C216.235 98.541 216.44 98.1607 216.801 98.0519C217.162 97.9431 217.542 98.1477 217.651 98.5088Z",
    fill: "url(#paint28_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.349 100.017C219.457 100.378 219.252 100.758 218.892 100.867C218.53 100.976 218.15 100.771 218.041 100.41C217.933 100.049 218.138 99.6689 218.498 99.561C218.859 99.4522 219.24 99.6567 219.349 100.017Z",
    fill: "url(#paint29_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.941 97.8205C220.05 98.1817 219.845 98.562 219.484 98.6708C219.123 98.7796 218.743 98.5742 218.634 98.2139C218.525 97.8527 218.731 97.4724 219.091 97.3636C219.452 97.2548 219.833 97.4602 219.941 97.8205Z",
    fill: "url(#paint30_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.638 99.3294C221.747 99.6905 221.542 100.071 221.181 100.179C220.82 100.288 220.44 100.082 220.332 99.7219C220.223 99.3607 220.428 98.9804 220.789 98.8716C221.15 98.7637 221.53 98.9682 221.638 99.3294Z",
    fill: "url(#paint31_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.232 97.1328C222.34 97.494 222.135 97.8743 221.775 97.9831C221.413 98.091 221.033 97.8865 220.924 97.5253C220.816 97.1642 221.021 96.7839 221.381 96.6759C221.743 96.5672 222.124 96.7717 222.232 97.1328Z",
    fill: "url(#paint32_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.929 98.6421C224.037 99.0033 223.832 99.3836 223.472 99.4924C223.111 99.6003 222.73 99.3958 222.622 99.0355C222.514 98.6743 222.719 98.294 223.079 98.1852C223.44 98.0764 223.82 98.281 223.929 98.6421Z",
    fill: "url(#paint33_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.521 96.4443C224.629 96.8055 224.425 97.1858 224.064 97.2937C223.703 97.4025 223.323 97.1971 223.214 96.8368C223.105 96.4756 223.311 96.0953 223.671 95.9865C224.032 95.8786 224.413 96.084 224.521 96.4443Z",
    fill: "url(#paint34_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.229 96.5647L195.266 97.7353C195.133 97.8972 194.932 97.9572 194.732 97.8954L193.284 97.449C193.064 97.3819 192.88 97.1783 192.802 96.9207L192.172 94.8242C192.057 94.4369 192.214 94.0479 192.525 93.9547L194.935 93.2307C195.246 93.1375 195.593 93.3751 195.709 93.7624L196.338 95.8589C196.417 96.1174 196.375 96.3881 196.229 96.5647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.877 102.753L195.84 101.582C195.973 101.42 196.173 101.36 196.374 101.422L197.822 101.868C198.041 101.936 198.226 102.139 198.303 102.397L198.934 104.493C199.05 104.881 198.892 105.27 198.581 105.363L196.17 106.087C195.86 106.18 195.513 105.942 195.397 105.555L194.767 103.459C194.689 103.201 194.732 102.93 194.877 102.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.111 99.5081L193.225 100.286C193.379 100.394 193.431 100.564 193.361 100.739L192.86 102.002C192.784 102.193 192.576 102.361 192.319 102.438L190.222 103.069C189.835 103.184 189.457 103.065 189.378 102.802L188.765 100.76C188.686 100.497 188.936 100.19 189.323 100.073L191.42 99.4437C191.676 99.3654 191.942 99.3907 192.111 99.5081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.091 100.129L197.976 99.3513C197.822 99.2434 197.771 99.0737 197.841 98.8988L198.342 97.6351C198.418 97.4437 198.626 97.2766 198.883 97.1991L200.98 96.569C201.367 96.4533 201.745 96.5716 201.824 96.8353L202.437 98.877C202.516 99.1407 202.266 99.448 201.879 99.5646L199.782 100.195C199.526 100.272 199.26 100.248 199.091 100.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.878 90.3622C201.184 90.571 200.452 90.1768 200.244 89.4832L199.988 88.6294C199.779 87.9358 200.173 87.2039 200.867 86.9959C201.56 86.787 202.292 87.1813 202.5 87.8749L202.756 88.7286C202.966 89.4223 202.571 90.1542 201.878 90.3622Z",
    fill: "#210042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.501 87.8748C202.709 88.5684 202.315 89.3003 201.622 89.5083C200.928 89.7172 200.196 89.323 199.988 88.6293C199.779 87.9357 200.173 87.2038 200.867 86.9958C201.561 86.7878 202.292 87.1812 202.501 87.8748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.889 81.3485C231.196 81.5574 230.464 81.1631 230.256 80.4695L229.999 79.6157C229.791 78.9221 230.184 78.1902 230.878 77.9822C231.572 77.7733 232.304 78.1676 232.512 78.8612L232.768 79.715C232.977 80.4086 232.584 81.1396 231.889 81.3485Z",
    fill: "#210042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.512 78.8613C232.72 79.5549 232.327 80.2868 231.633 80.4948C230.939 80.7037 230.207 80.3094 229.999 79.6158C229.791 78.9222 230.185 78.1903 230.878 77.9823C231.572 77.7734 232.303 78.1668 232.512 78.8613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.253 83.3413C242.568 83.3413 243.633 82.276 243.633 80.9619C243.633 79.6478 242.568 78.5825 241.253 78.5825C239.939 78.5825 238.874 79.6478 238.874 80.9619C238.874 82.276 239.939 83.3413 241.253 83.3413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.373 92.0979C246.991 90.9384 246.553 89.497 245.393 88.8786C244.234 88.2602 242.792 88.6989 242.174 89.8584C241.556 91.018 241.994 92.4593 243.154 93.0777C244.313 93.6962 245.755 93.2575 246.373 92.0979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.026 86.794C240.404 88.0524 239.691 89.3796 238.432 89.7573C237.174 90.135 235.846 89.4214 235.469 88.1629C235.091 86.9045 235.805 85.5773 237.063 85.1996C238.322 84.821 239.649 85.5347 240.026 86.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.049 83.7837C250.427 85.0421 249.713 86.3693 248.455 86.747C247.196 87.1247 245.869 86.4111 245.491 85.1526C245.114 83.8942 245.827 82.567 247.086 82.1893C248.344 81.8107 249.67 82.5252 250.049 83.7837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.303 86.4265L236.682 86.9133L237.169 88.5344L238.79 88.0476L238.303 86.4265Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.809 79.9111L240.188 80.3982L240.675 82.0201L242.297 81.5331L241.809 79.9111Z",
    fill: "#E47272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.834 89.9814L243.212 90.4685L243.699 92.0896L245.321 91.6026L244.834 89.9814Z",
    fill: "#E05C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.338 83.47L246.717 83.9568L247.204 85.5787L248.825 85.0919L248.338 83.47Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.407 83.7032C251.197 80.3961 248.256 77.8401 244.528 77.2979C239.113 76.5085 234.083 80.2595 233.292 85.6753C233.106 86.9442 233.171 88.1948 233.449 89.3723C232.901 87.878 232.706 86.2297 232.953 84.5439C233.744 79.1264 238.774 75.378 244.188 76.1665C248.331 76.7714 251.501 79.8592 252.407 83.7032Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.151 97.8971C203.94 94.59 201 92.0339 197.271 91.4917C191.857 90.7024 186.827 94.4533 186.036 99.8692C185.849 101.138 185.915 102.389 186.192 103.566C185.645 102.072 185.449 100.424 185.696 98.7378C186.487 93.3202 191.518 89.5719 196.932 90.3604C201.074 90.9643 204.245 94.053 205.151 97.8971Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.045 158.088V198.603C214.045 201.098 212.439 203.465 210.427 203.895L148.242 217.204C144.985 217.901 142.292 215.837 142.292 212.582V159.715C142.292 156.459 144.984 153.81 148.242 153.799L210.427 153.583C212.439 153.576 214.045 155.593 214.045 158.088Z",
    fill: "#F5F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.045 158.088V158.65L142.292 160.449V159.715C142.292 156.459 144.984 153.81 148.242 153.799L210.427 153.583C212.439 153.576 214.045 155.593 214.045 158.088Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.689 156.999C151.689 157.959 150.911 158.753 149.945 158.772C148.973 158.792 148.18 158.02 148.18 157.049C148.18 156.078 148.973 155.284 149.945 155.275C150.911 155.268 151.689 156.04 151.689 156.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.66 156.914C157.66 157.855 156.912 158.632 155.985 158.651C155.052 158.669 154.292 157.914 154.292 156.963C154.292 156.012 155.052 155.233 155.985 155.226C156.912 155.218 157.66 155.974 157.66 156.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.394 156.832C163.394 157.755 162.676 158.517 161.785 158.535C160.889 158.553 160.158 157.812 160.158 156.879C160.158 155.946 160.889 155.184 161.785 155.176C162.676 155.169 163.394 155.911 163.394 156.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.824 172.807L189.837 178.608C190.869 179.152 190.869 180.855 189.837 181.617L178.824 189.74C177.741 190.539 176.409 189.855 176.409 188.488V174.567C176.409 173.201 177.741 172.237 178.824 172.807Z",
    fill: "#E47272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.16 203.952L148.665 217.113C145.178 217.859 142.292 215.646 142.292 212.153V207.653L214.045 194.826V198.275C214.045 200.952 212.321 203.49 210.16 203.952Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.429 204.355C189.436 203.865 189.42 203.372 189.388 202.881L156.595 209.321C156.098 209.419 155.774 209.902 155.871 210.399C155.957 210.836 156.341 211.139 156.77 211.139C156.829 211.139 156.888 211.134 156.948 211.122L189.417 204.745C189.42 204.616 189.427 204.485 189.429 204.355Z",
    fill: "#E47272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.392 198.756L190.632 202.636C190.707 203.145 190.759 203.656 190.805 204.168C190.814 204.268 190.818 204.368 190.826 204.468L210.746 200.556C211.243 200.459 211.567 199.976 211.469 199.479C211.371 198.982 210.89 198.66 210.392 198.756Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.888 212.883C147.459 212.883 147.074 212.58 146.988 212.143C146.891 211.646 147.214 211.163 147.711 211.065L164.17 207.832C164.668 207.734 165.15 208.058 165.248 208.555C165.345 209.052 165.021 209.535 164.524 209.633L148.065 212.866C148.006 212.878 147.947 212.883 147.888 212.883Z",
    fill: "#E47272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.393 203.196C192.393 204.998 191.006 206.749 189.276 207.108C187.525 207.473 186.089 206.277 186.089 204.434C186.089 202.592 187.525 200.832 189.276 200.509C191.006 200.188 192.393 201.394 192.393 203.196Z",
    fill: "#E47272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.82 203.505C190.82 204.398 190.13 205.261 189.276 205.434C188.416 205.608 187.714 205.018 187.714 204.115C187.714 203.213 188.415 202.347 189.276 202.183C190.13 202.02 190.82 202.612 190.82 203.505Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M119.999 191.503C120 191.517 120 191.537 120.008 191.558L120.705 214.792C120.496 207.796 131.806 201.095 150.402 195.844L149.703 172.555C131.1 177.807 119.79 184.507 119.999 191.503Z",
    fill: "url(#paint35_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M142.303 182.477C130.185 186.594 122.284 191.402 120.255 196.452C120.294 197.495 120.327 198.54 120.352 199.585C122.611 194.487 130.829 189.642 143.323 185.521C144 185.297 144.455 184.658 144.433 183.946C144.399 182.865 143.326 182.13 142.303 182.477Z",
    fill: "url(#paint36_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M142.304 188.759C130.477 192.777 122.682 197.456 120.428 202.373C120.434 203.474 120.433 204.574 120.431 205.674C122.809 200.646 130.986 195.873 143.322 191.803C143.998 191.58 144.456 190.941 144.433 190.229V190.227C144.4 189.148 143.326 188.412 142.304 188.759Z",
    fill: "url(#paint37_linear_2203_1589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.967 190.326L120.666 213.618C121.022 225.515 154.631 234.561 200.348 236.384L199.648 213.087C153.933 211.27 120.324 202.223 119.967 190.326Z",
    fill: "#D9D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.419 124.358C271.713 124.358 270.088 123.744 268.799 122.604L271.23 119.856C271.894 120.444 272.739 120.743 273.632 120.682C274.516 120.628 275.327 120.233 275.913 119.569C276.501 118.905 276.794 118.053 276.74 117.168C276.685 116.284 276.29 115.473 275.627 114.886L278.059 112.137C279.456 113.374 280.289 115.081 280.403 116.943C280.518 118.806 279.899 120.602 278.663 122C277.426 123.397 275.719 124.23 273.856 124.344C273.71 124.354 273.565 124.358 273.419 124.358Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.536 124.408C423.623 124.408 422.711 124.227 421.843 123.864C420.122 123.144 418.783 121.798 418.073 120.071C417.365 118.345 417.37 116.447 418.09 114.724C418.809 113.003 420.157 111.663 421.882 110.954L423.277 114.348C422.457 114.685 421.817 115.32 421.476 116.138C421.135 116.956 421.132 117.858 421.468 118.678C421.805 119.498 422.441 120.137 423.258 120.479C424.076 120.821 424.977 120.822 425.797 120.487L427.191 123.881C426.334 124.232 425.435 124.408 424.536 124.408Z",
    fill: "#E6BC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.756 45.4491C160.843 45.4491 159.93 45.2681 159.063 44.9052C157.34 44.1854 156.002 42.8391 155.293 41.1124C153.83 37.5477 155.539 33.4573 159.102 31.9944L160.496 35.3885C158.804 36.083 157.992 38.0255 158.687 39.7182C159.382 41.4101 161.323 42.2212 163.015 41.5267L164.41 44.9208C163.553 45.2733 162.654 45.4491 161.756 45.4491Z",
    fill: "#E6BC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1095 151.265C60.2392 151.265 58.3742 150.522 57 149.05L59.6822 146.545C60.9302 147.881 63.0329 147.954 64.3714 146.706C65.7081 145.458 65.7804 143.355 64.5315 142.018L67.2137 139.513C69.8429 142.329 69.6915 146.759 66.8752 149.389C65.5315 150.644 63.8187 151.265 62.1095 151.265Z",
    fill: "#CFE1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.282 135.667C177.177 135.667 177.175 142.038 181.282 142.038C185.388 142.038 185.39 135.667 181.282 135.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.639 82.782C412.534 82.782 412.532 89.1534 416.639 89.1534C420.745 89.1534 420.747 82.782 416.639 82.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.549 231.862C334.444 231.862 334.442 238.233 338.549 238.233C342.655 238.233 342.657 231.862 338.549 231.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.041 59.7939C106.936 59.7939 106.934 66.1653 111.041 66.1653C115.146 66.1653 115.148 59.7939 111.041 59.7939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.051 23.636C252.704 23.636 252.703 27.2764 255.051 27.2764C257.396 27.2764 257.398 23.636 255.051 23.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.162 135.531C236.816 135.531 236.815 139.172 239.162 139.172C241.508 139.172 241.509 135.531 239.162 135.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.843 120.656C309.497 120.656 309.496 124.296 311.843 124.296C314.188 124.297 314.19 120.656 311.843 120.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.745 68.9346C326.399 68.9346 326.398 72.575 328.745 72.575C331.092 72.575 331.093 68.9346 328.745 68.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.581 28.7061C386.235 28.7061 386.234 32.3465 388.581 32.3465C390.927 32.3474 390.928 28.7061 388.581 28.7061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.073 174.745C373.726 174.745 373.725 178.386 376.073 178.386C378.419 178.385 378.42 174.745 376.073 174.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.111 187.59C304.764 187.59 304.763 191.231 307.111 191.231C309.456 191.232 309.457 187.59 307.111 187.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.201 245.398C191.855 245.398 191.854 249.038 194.201 249.038C196.547 249.038 196.548 245.398 194.201 245.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.097 171.702C112.751 171.702 112.75 175.343 115.097 175.343C117.443 175.343 117.444 171.702 115.097 171.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.784 107.473C66.4377 107.473 66.4368 111.113 68.784 111.113C71.1303 111.113 71.1312 107.473 68.784 107.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.426 39.8625C184.08 39.8625 184.079 43.503 186.426 43.503C188.772 43.503 188.772 39.8625 186.426 39.8625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.301 143.982C413.955 143.982 413.954 147.622 416.301 147.622C418.647 147.623 418.648 143.982 416.301 143.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.502 323.098C297.502 323.098 314.074 327.799 321.931 328.118L331.34 332.411C332.591 332.981 332.944 334.593 332.047 335.634C331.543 336.22 330.753 336.475 330.002 336.294L321.62 334.28L300.526 334.442L297.502 323.098Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.951 333.05C292.861 338.157 304.479 336.298 308.506 336.298C311.547 336.298 317.325 336.176 319.974 336.116C320.811 336.096 321.544 335.56 321.818 334.769C322.227 333.59 321.468 332.328 320.235 332.135L310.823 330.662L296.451 322.822L291.951 333.05Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5 324.623L321.93 326.888L327.838 332.542C328.578 333.249 328.654 334.404 328.015 335.203C327.372 336.007 326.218 336.183 325.364 335.606L320.234 332.135L302.499 332.559V324.623H302.5Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.979 223.097C298.466 252.656 301.744 312.34 301.744 312.34L279.763 311.302L277.469 228.734L290.979 223.097Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.06 220.464C211.072 250.87 214.197 280.118 199.725 326.871L212.597 333.05C230.056 302.307 239.48 229.429 239.48 229.429L222.06 220.464Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.045 323.098C207.045 323.098 190.474 327.799 182.617 328.118L173.207 332.411C171.956 332.981 171.603 334.593 172.5 335.634C173.005 336.22 173.794 336.475 174.546 336.294L182.928 334.28L204.022 334.442L207.045 323.098Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.597 333.05C211.686 338.157 200.069 336.298 196.041 336.298C193 336.298 187.221 336.176 184.573 336.116C183.737 336.096 183.003 335.56 182.729 334.769C182.321 333.59 183.08 332.328 184.312 332.135L193.724 330.662L208.096 322.822L212.597 333.05Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.047 324.623L182.618 326.888L176.709 332.542C175.97 333.249 175.893 334.404 176.532 335.203C177.175 336.007 178.329 336.183 179.182 335.606L184.312 332.135L202.047 332.559V324.623Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.064 274.271L219.774 308.787C219.774 308.787 218.044 336.312 251.756 335.692C285.468 335.073 290.98 314.517 290.98 314.517L276.404 274.271H230.064Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.749 296.432C223.288 298.789 223.026 299.837 223.026 299.837C223.026 299.837 248.744 312.426 288.385 299.138L288.003 294.598L285.368 263.555L285.384 263.546L286.852 263.039L287.13 262.943L303.489 257.244C302.846 254.839 302.219 252.545 301.608 250.362C296.568 232.304 292.726 221.692 288.789 218.215C285.424 215.246 279.923 215.921 272.104 219.159C267.619 221.009 262.381 223.707 256.34 227.041C256.34 227.041 250.148 222.937 242.869 219.636C236.217 216.612 228.661 214.254 224.121 216.318C218.184 219.009 213.024 238.622 210.635 249.172C209.738 253.156 209.23 255.847 209.23 255.847L226.511 260.395L228.455 260.903L228.686 260.967L228.765 260.99C226.606 280.429 224.725 291.399 223.749 296.432Z",
    fill: "#8484FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.027 299.837C223.027 299.837 248.744 312.426 288.385 299.138L288.004 294.598C268.001 298.313 237.124 297.17 223.749 296.432C223.289 298.789 223.027 299.837 223.027 299.837Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.987 257.363L286.853 263.038L287.13 262.942L303.49 257.243C302.846 254.838 302.219 252.544 301.609 250.361L285.987 257.363Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.117 224.398C242.117 232.939 249.031 239.853 257.563 239.853C266.096 239.853 273.018 232.939 273.018 224.398C273.018 222.556 272.692 220.795 272.105 219.159C267.621 221.009 262.382 223.707 256.341 227.042C256.341 227.042 250.15 222.938 242.871 219.636C242.379 221.136 242.117 222.739 242.117 224.398Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.192 278.211C245.295 277.533 247.027 277.744 248.297 277.633C249.658 277.515 251.015 277.358 252.368 277.168C255.104 276.786 257.807 276.239 260.489 275.58C265.875 274.257 271.104 272.458 276.076 269.99C277.288 269.388 278.335 271.181 277.123 271.834C272.078 274.555 266.749 276.837 261.229 278.399C258.465 279.182 255.635 279.773 252.797 280.216C251.423 280.431 250.039 280.599 248.654 280.737C247.246 280.877 245.496 281.297 244.191 280.659C243.185 280.166 243.331 278.739 244.192 278.211Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.241 270.133C245.425 269.693 246.969 270.241 248.196 270.358C249.557 270.488 250.928 270.56 252.295 270.561C254.974 270.563 257.676 270.321 260.297 269.761C261.55 269.494 262.043 271.327 260.803 271.693C258.015 272.517 255.197 273.073 252.295 273.278C250.878 273.378 249.462 273.397 248.044 273.324C246.577 273.247 244.828 273.307 243.643 272.344C242.786 271.65 243.41 270.442 244.241 270.133Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.316 303.087C239.992 296.112 206.11 263.182 195.84 279.189C185.57 295.196 198.639 318.66 222.115 329.971C245.592 341.282 265.741 329.847 245.316 303.087Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.566 291.723C197.973 299.567 203.595 306.184 209.808 311.956C213.08 314.996 216.569 317.792 220.137 320.474C223.571 323.055 227.039 325.628 230.605 328.025C234.171 330.422 237.994 332.368 242.369 332.535C243.332 332.571 243.222 333.914 242.315 333.989C238.358 334.318 234.56 332.506 231.279 330.469C227.633 328.205 224.188 325.567 220.741 323.016C213.534 317.684 206.511 311.956 201.095 304.745C198.148 300.821 195.737 296.604 194.056 291.987C193.932 291.649 194.415 291.375 194.566 291.723Z",
    fill: "#3A6885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.827 292.155C240.975 296.851 246.373 302.687 250.115 309.497C251.173 311.423 252.115 313.409 252.945 315.444C253.354 316.447 251.81 317.144 251.405 316.133C248.576 309.084 244.44 302.571 239.224 297.051C237.741 295.481 236.174 293.976 234.508 292.602C234.237 292.379 234.543 291.939 234.827 292.155Z",
    fill: "#3A6885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.982 349.222L305.894 323.702C302.416 322.67 299.41 322.37 299.41 322.37L286.529 346.809C294.163 349.834 295.982 349.222 295.982 349.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.546 344.947C288.612 345.682 287.609 346.312 286.534 346.82C285.141 346.266 283.33 345.482 281.103 344.535C279.034 343.653 276.604 342.601 273.837 341.422C270.839 340.142 267.435 338.707 263.637 337.153C263.549 332.483 264.142 327.319 265.627 322.851L265.637 322.85C273.309 324.372 285.554 322.525 294.375 322.208C296.647 322.12 298.435 322.152 299.407 322.374C300.439 323.636 298.025 338.304 289.546 344.947Z",
    fill: "#3A6885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.044 317.944C249.908 317.412 248.701 316.833 247.397 316.172C248.7 316.832 249.909 317.421 251.044 317.944Z",
    fill: "#E0954A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54 312.069L239.542 312.078C239.967 312.305 240.383 312.525 240.79 312.746C240.381 312.516 239.966 312.297 239.54 312.069Z",
    fill: "#E0954A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.627 322.851C264.142 327.319 263.549 332.483 263.637 337.153C257.147 334.486 248.693 333.699 240.105 330.512L239.538 312.079C239.964 312.307 240.38 312.526 240.786 312.748C241.608 313.188 242.407 313.603 243.167 314.004C243.918 314.407 244.646 314.784 245.354 315.145C245.354 315.145 245.354 315.145 245.363 315.144C246.061 315.506 246.738 315.852 247.385 316.173C247.394 316.172 247.394 316.172 247.394 316.172C248.697 316.833 249.906 317.421 251.04 317.944C253.03 318.875 254.777 319.618 256.416 320.245C256.873 320.422 257.329 320.589 257.775 320.748C258.001 320.822 258.229 320.906 258.455 320.971C258.891 321.132 259.323 321.264 259.756 321.397C259.972 321.463 260.189 321.529 260.414 321.594C260.836 321.719 261.258 321.843 261.688 321.957C262.978 322.289 264.262 322.585 265.627 322.851Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.108 330.51L239.541 312.078L239.54 312.069L239.531 312.07L240.108 330.51Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.207 344.593C279.074 343.681 276.576 342.601 273.733 341.393C276.053 340.61 280.208 341.491 281.207 344.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.412 322.374C301.634 325.643 299.122 339.909 289.552 344.947C286.104 334.862 289.935 321.81 299.412 322.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.262 316.447C265.297 316.521 264.613 317.289 264.402 318.296C263.94 320.499 265.551 323.235 266.86 324.939C268.161 326.634 269.75 327.965 271.528 328.853C270.093 328.924 268.704 329.258 267.412 329.909C265.544 330.852 263.717 332.425 262.796 334.487C261.967 336.343 262.269 339.28 264.429 340.194C266.574 341.1 268.656 339.165 269.981 337.74C271.531 336.075 272.944 333.784 273.521 331.328C273.394 332.956 273.452 334.616 273.636 336.268C273.665 336.531 274.004 336.509 273.996 336.256C273.942 334.41 274.101 332.596 274.367 330.81C274.499 329.929 274.667 329.058 274.887 328.208C275.096 327.399 275.489 326.567 275.58 325.723C275.623 325.313 275.102 324.98 274.872 325.328C274.489 325.908 274.313 326.712 274.15 327.445C273.82 323.657 271.713 319.683 268.837 317.468C268.084 316.89 267.158 316.379 266.262 316.447ZM270.367 335.656C269.286 337.173 267.684 339.068 265.811 339.365C264.872 339.513 263.976 339.042 263.532 338.026C263.064 336.954 263.251 335.8 263.709 334.865C264.572 333.101 266.159 331.772 267.781 330.922C269.361 330.095 271.143 329.704 272.957 329.727C272.952 329.738 272.944 329.745 272.939 329.759C272.271 331.893 271.628 333.885 270.367 335.656ZM268.692 318.527C270.086 319.766 271.237 321.366 272.03 323.118C272.83 324.888 273.221 326.783 273.378 328.683C273.351 328.666 273.328 328.644 273.296 328.633C271.485 327.954 269.787 326.754 268.397 325.243C267.085 323.816 265.843 321.871 265.405 319.921C265.178 318.908 265.361 317.551 266.45 317.456C267.246 317.386 268.066 317.971 268.692 318.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.76 326.832C276.677 330.177 276.749 334.089 277.684 337.669C277.758 337.952 278.193 337.874 278.132 337.584C277.767 335.839 277.606 334.053 277.655 332.306C277.705 330.535 278.02 328.877 278.452 327.219C278.493 327.062 278.483 326.835 278.331 326.72C278.273 326.676 278.224 326.639 278.156 326.623C278 326.584 277.814 326.666 277.76 326.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.176 326.769C280.741 329.975 280.084 333.768 280.023 337.453C280.015 337.882 280.609 338.053 280.638 337.609C280.758 335.811 281.009 334.028 281.379 332.298C281.758 330.523 282.34 328.869 282.941 327.196C283.132 326.666 282.402 326.264 282.176 326.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.063 326.878C286.023 326.886 285.983 326.894 285.943 326.903C285.804 326.931 285.737 327.085 285.705 327.219C285.493 328.126 285.182 328.991 284.983 329.906C284.783 330.818 284.625 331.744 284.504 332.68C284.266 334.526 284.195 336.388 284.293 338.284C284.313 338.654 284.884 338.723 284.886 338.35C284.893 336.509 285.006 334.665 285.257 332.871C285.379 332.004 285.533 331.145 285.72 330.299C285.926 329.368 286.112 328.388 286.459 327.521C286.513 327.384 286.489 327.216 286.405 327.084C286.384 327.052 286.363 327.02 286.343 326.988C286.273 326.88 286.165 326.857 286.063 326.878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.339 332.269L251.266 335.14L256.842 318.296L236.789 306.575L239.339 332.269Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4 289.909C289.937 292.223 246.692 311.258 257.67 326.788C268.648 342.317 295.303 339.018 314.603 321.507C333.903 303.997 330.872 281.028 298.4 289.909Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.761 352.156L207.946 327.004C211.386 325.849 214.379 325.442 214.379 325.442L228.121 349.407C220.6 352.702 218.761 352.156 218.761 352.156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.155 324.719C249.799 329.132 250.575 334.272 250.654 338.941C246.914 340.629 243.562 342.185 240.612 343.571C237.889 344.847 235.497 345.985 233.462 346.941C231.27 347.966 229.489 348.814 228.116 349.418C227.023 348.948 225.998 348.354 225.039 347.653C216.329 341.316 213.394 326.744 214.381 325.446C215.345 325.189 217.13 325.093 219.404 325.1C228.23 325.103 240.533 326.513 248.146 324.719L248.155 324.719Z",
    fill: "#3A6885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.557 319.296C263.673 318.724 264.859 318.103 266.138 317.396C264.859 318.102 263.673 318.734 262.557 319.296Z",
    fill: "#E0954A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.844 313.016L273.843 313.025C273.426 313.268 273.018 313.502 272.621 313.737C273.019 313.493 273.427 313.259 273.844 313.016Z",
    fill: "#E0954A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.933 331.467C265.465 334.957 257.044 336.045 250.653 338.941C250.575 334.272 249.798 329.132 248.154 324.719C249.509 324.405 250.782 324.064 252.058 323.686C252.484 323.557 252.901 323.417 253.318 323.278C253.541 323.205 253.755 323.132 253.969 323.058C254.396 322.91 254.824 322.762 255.254 322.586C255.477 322.513 255.702 322.422 255.926 322.339C256.366 322.164 256.815 321.981 257.266 321.788C258.881 321.103 260.602 320.297 262.557 319.296C263.672 318.734 264.859 318.103 266.139 317.396C266.139 317.396 266.147 317.407 266.148 317.397C266.782 317.053 267.447 316.683 268.132 316.296C268.141 316.296 268.141 316.296 268.141 316.296C268.835 315.911 269.55 315.508 270.285 315.079C271.031 314.651 271.815 314.207 272.62 313.738C273.018 313.503 273.425 313.269 273.843 313.026L273.933 331.467Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.933 331.467L273.844 313.025L273.844 313.016L273.854 313.017L273.933 331.467Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.362 347.004C235.46 346.015 237.919 344.848 240.717 343.539C238.371 342.839 234.25 343.867 233.362 347.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.377 325.447C212.273 328.792 215.291 342.96 225.034 347.654C228.121 337.453 223.828 324.545 214.377 325.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.759 319.456C241.963 321.772 239.999 325.819 239.804 329.616C239.615 328.889 239.411 328.091 239.007 327.526C238.765 327.186 238.256 327.538 238.314 327.946C238.434 328.786 238.857 329.604 239.095 330.405C239.344 331.247 239.543 332.111 239.706 332.987C240.036 334.762 240.259 336.57 240.271 338.416C240.272 338.669 240.611 338.68 240.631 338.416C240.757 336.757 240.756 335.096 240.571 333.474C241.235 335.908 242.728 338.147 244.336 339.756C245.712 341.132 247.861 342.993 249.973 342.01C252.1 341.02 252.297 338.074 251.402 336.249C250.408 334.221 248.526 332.714 246.625 331.839C245.311 331.234 243.911 330.949 242.474 330.93C244.219 329.979 245.76 328.592 247 326.852C248.248 325.102 249.76 322.311 249.22 320.126C248.973 319.128 248.262 318.385 247.295 318.345C246.397 318.307 245.49 318.85 244.759 319.456ZM241.095 331.884C241.091 331.871 241.082 331.864 241.076 331.853C242.888 331.764 244.683 332.092 246.292 332.863C247.943 333.654 249.576 334.926 250.502 336.657C250.992 337.577 251.221 338.722 250.791 339.811C250.384 340.841 249.505 341.344 248.561 341.229C246.679 341 245.011 339.163 243.877 337.685C242.554 335.961 241.84 333.993 241.095 331.884ZM247.144 319.357C248.235 319.414 248.467 320.763 248.276 321.783C247.908 323.748 246.735 325.736 245.475 327.208C244.14 328.768 242.484 330.027 240.699 330.77C240.668 330.784 240.645 330.806 240.619 330.824C240.708 328.919 241.033 327.012 241.768 325.214C242.497 323.435 243.59 321.796 244.94 320.508C245.547 319.93 246.345 319.317 247.144 319.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.174 329.131C237.376 332.435 237.443 336.347 236.636 339.958C236.571 340.245 236.134 340.181 236.185 339.89C236.487 338.133 236.584 336.342 236.473 334.598C236.361 332.83 235.987 331.185 235.496 329.542C235.45 329.387 235.451 329.16 235.599 329.04C235.656 328.994 235.703 328.955 235.771 328.936C235.926 328.892 236.114 328.966 236.174 329.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.759 329.225C233.308 332.379 234.099 336.146 234.291 339.826C234.314 340.255 233.727 340.446 233.681 340.004C233.499 338.211 233.184 336.438 232.752 334.722C232.31 332.962 231.669 331.329 231.009 329.68C230.8 329.156 231.515 328.728 231.759 329.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.877 329.473C227.917 329.479 227.958 329.486 227.998 329.493C228.138 329.515 228.211 329.667 228.247 329.8C228.491 330.699 228.833 331.553 229.064 332.459C229.296 333.363 229.487 334.284 229.641 335.215C229.945 337.052 230.082 338.91 230.052 340.809C230.046 341.178 229.477 341.268 229.463 340.894C229.39 339.055 229.212 337.216 228.896 335.432C228.744 334.569 228.559 333.717 228.342 332.878C228.103 331.955 227.881 330.983 227.505 330.128C227.445 329.993 227.463 329.823 227.543 329.689C227.562 329.657 227.582 329.624 227.602 329.592C227.668 329.481 227.775 329.456 227.877 329.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.093 310.373C273.624 310.515 251.905 321.867 251.905 321.867L258.178 337.738L279.246 333.255L274.093 310.373Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.336 321.715C254.943 320.185 257.688 318.931 260.475 317.771C260.461 317.408 260.458 317.045 260.477 316.681C260.655 313.217 262.231 309.901 264.677 307.464C264.903 307.238 265.257 307.575 265.036 307.806C262.75 310.2 261.54 313.445 261.661 316.751C261.715 318.201 262.007 319.65 262.547 320.998C262.808 321.647 263.116 322.279 263.47 322.881C263.858 323.538 264.465 324.141 264.72 324.856C264.935 325.463 264.161 326.067 263.621 325.727C262.926 325.291 262.479 324.413 262.096 323.705C261.698 322.97 261.357 322.195 261.11 321.397C260.869 320.621 260.69 319.823 260.581 319.017C258.058 320.209 255.625 321.589 253.228 323.017C254.665 327.375 256.351 331.655 258.227 335.842C261.246 334.41 264.717 333.584 268.059 333.757C267.623 333.273 267.23 332.751 266.909 332.183C266.183 330.9 265.836 329.52 265.71 328.06C265.687 327.791 266.136 327.722 266.185 327.993C266.417 329.289 267.061 330.525 267.866 331.559C268.159 331.935 268.497 332.279 268.848 332.607C268.94 332.572 269.04 332.546 269.158 332.547C277.574 332.647 285.944 330.999 293.752 327.876C301.51 324.772 308.711 320.344 314.863 314.681C318.345 311.476 321.577 307.908 324.245 303.994C324.456 303.685 324.969 303.957 324.762 304.278C322.438 307.866 319.846 311.26 316.856 314.322C313.859 317.392 310.538 320.156 307.01 322.595C299.967 327.464 291.994 330.914 283.629 332.735C279.476 333.639 275.234 334.143 270.985 334.217C271.171 334.454 271.224 334.778 271.066 335.065C270.862 335.438 270.386 335.567 270.015 335.371C269.711 335.212 269.417 335.009 269.135 334.787C269.043 334.975 268.864 335.118 268.574 335.115C266.767 335.102 265.017 335.186 263.247 335.585C261.501 335.98 259.827 336.6 258.241 337.429C257.925 337.594 257.42 337.553 257.251 337.181C255.129 332.53 253.43 327.722 252.096 322.789C251.885 322.45 251.894 321.975 252.336 321.715Z",
    fill: "#3A6885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.219 248.623C233.682 248.233 237.175 248.863 240.647 249.072C244.072 249.278 247.503 249.374 250.933 249.361C257.828 249.333 264.724 248.85 271.567 248.017C275.456 247.543 279.355 247.052 283.26 246.729C284.594 246.619 284.516 248.523 283.448 248.886C276.821 251.136 269.729 252.045 262.776 252.58C255.808 253.116 248.806 253.2 241.828 252.828C239.925 252.726 238.023 252.591 236.125 252.421C234.041 252.236 232.076 252.046 230.109 251.308C228.935 250.868 228.723 248.792 230.219 248.623Z",
    fill: "#EBF4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.229 257.071C236.499 257.973 243.714 259.093 251.042 259.517C258.285 259.936 265.555 259.843 272.793 259.419C276.956 259.176 281.131 259.073 285.265 258.529C286.486 258.369 286.893 260.107 285.66 260.353C282.056 261.071 278.468 261.95 274.815 262.413C271.069 262.889 267.298 263.18 263.521 263.307C256.073 263.557 248.58 263.318 241.173 262.459C236.941 261.968 232.739 261.361 228.622 260.287C226.763 259.805 227.28 256.83 229.229 257.071Z",
    fill: "#EBF4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.734 246.179C283.606 246.497 283.702 246.791 283.885 247.013C283.893 247.076 283.893 247.14 283.9 247.203C284.099 250.005 284.289 252.815 284.519 255.616C284.638 256.981 284.749 258.355 284.868 259.729C284.971 260.999 285.003 262.316 285.384 263.547L287.131 262.943C287.194 261.872 287.06 260.809 286.964 259.729C286.837 258.292 286.71 256.855 286.583 255.418C286.344 252.68 286.059 249.941 285.781 247.203C285.765 247.052 285.749 246.902 285.734 246.751C286.202 246.06 286.544 245.258 286.861 244.505C287.219 243.648 287.544 242.774 287.829 241.885C288.409 240.091 288.806 238.234 289.06 236.361C289.107 235.996 288.964 235.614 288.559 235.519C288.218 235.432 287.773 235.638 287.71 236.011C287.416 237.821 286.932 239.583 286.242 241.282C285.98 241.925 285.67 242.552 285.353 243.171C284.884 238.9 284.361 234.638 283.876 230.368C283.812 229.764 282.876 229.732 282.908 230.368C283.217 235.574 283.463 240.789 283.82 245.996C283.789 246.06 283.757 246.115 283.734 246.179Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.162 240.194C225.583 241.98 225.956 243.774 226.384 245.56C226.599 246.441 226.805 247.314 227.027 248.187C227.202 248.917 227.273 249.918 227.789 250.505C227.614 252.219 227.432 253.934 227.225 255.641C227.043 257.22 226.726 258.808 226.511 260.395L228.686 260.967C228.988 259.204 229.106 257.371 229.297 255.641C229.551 253.276 229.702 250.91 229.75 248.528C229.852 243.623 229.805 238.774 229.44 233.884C229.393 233.225 228.393 233.209 228.408 233.884C228.511 237.916 228.464 242.011 228.178 246.052C228.091 245.758 228.003 245.456 227.908 245.163C227.376 243.401 226.78 241.662 226.241 239.908C226.027 239.225 224.995 239.495 225.162 240.194Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.231 255.846L226.512 260.394L228.456 260.902L229.298 255.64L210.636 249.171C209.739 253.156 209.231 255.846 209.231 255.846Z",
    fill: "#706CD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.687 205.157L272.389 206.435C269.618 207.104 266.83 205.4 266.162 202.629L264.574 196.046C263.905 193.275 265.61 190.487 268.38 189.82L273.679 188.541C276.45 187.873 279.237 189.577 279.905 192.348L281.493 198.931C282.162 201.701 280.458 204.488 277.687 205.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.058 206.242C268.914 206.242 267.063 204.783 266.559 202.695L264.897 195.805C264.297 193.321 265.831 190.814 268.314 190.215L270.259 189.746C270.618 189.659 270.985 189.615 271.35 189.615C273.495 189.615 275.345 191.074 275.85 193.163L277.511 200.052C277.802 201.255 277.606 202.499 276.961 203.555C276.315 204.611 275.297 205.352 274.094 205.642L272.149 206.111C271.79 206.198 271.423 206.242 271.058 206.242Z",
    fill: "#D9DADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.351 189.986C273.324 189.986 275.027 191.328 275.49 193.251L277.152 200.14C277.704 202.425 276.293 204.732 274.008 205.283L272.063 205.753C271.733 205.833 271.395 205.873 271.059 205.873C269.086 205.873 267.383 204.531 266.92 202.609L265.258 195.719C264.991 194.612 265.171 193.468 265.765 192.497C266.359 191.525 267.295 190.843 268.402 190.576L270.348 190.107C270.676 190.026 271.015 189.986 271.351 189.986ZM271.35 189.246C270.961 189.246 270.567 189.292 270.173 189.387L268.228 189.856C265.542 190.504 263.89 193.206 264.538 195.892L266.199 202.782C266.752 205.074 268.801 206.613 271.058 206.613C271.447 206.613 271.842 206.567 272.236 206.472L274.181 206.003C276.867 205.355 278.519 202.653 277.872 199.966L276.21 193.077C275.657 190.785 273.608 189.245 271.35 189.246Z",
    fill: "#5186C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.594 204.673C233.837 200.489 231.543 193.898 231.543 193.898C229.462 194.502 227.305 192.466 228.949 190.158C225.305 190.084 231.053 178.285 238.62 180.773L244.73 202.482L237.594 204.673Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.184 176.156C274.589 184.151 273.726 195.094 273.726 195.094L263.272 179.005L268.184 176.156Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.363 203.15L266.544 210.565L266.754 219.094L266.969 223.555C267.208 228.48 263.571 232.739 258.67 233.277C253.732 233.819 249.235 230.395 248.445 225.49L244.238 199.392L266.363 203.15Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.592 208.994L266.806 220.176C257.357 221.122 250.872 214.279 249.148 209.131C253.21 207.761 266.592 208.994 266.592 208.994Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.445 202.548C237.49 202.348 235.312 203.14 234.419 204.891C233.675 206.349 233.956 208.13 234.569 209.648C235.36 211.606 236.708 213.375 238.523 214.452C240.339 215.53 242.639 215.855 244.61 215.1C246.582 214.345 248.124 212.442 248.238 210.334C248.455 206.289 242.958 202.907 239.445 202.548Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.685 208.954C241.782 207.634 239.779 207.711 237.631 208.268C237.313 208.351 237.384 208.895 237.724 208.851C239.484 208.622 241.531 209.633 242.787 210.555C242.965 210.687 243.294 210.695 243.495 210.635C243.707 210.572 243.935 210.404 244.036 210.203C244.278 209.723 244.107 209.248 243.685 208.954Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.346 180.344C264.41 178.798 261.989 178.111 259.414 178.061C252.846 177.921 245.257 181.943 242.067 186.694C237.404 193.636 238.891 201.937 243.545 208.13C245.671 210.986 248.476 213.4 251.658 215.019C257.232 217.863 264.416 218.478 269.455 214.766C273.094 212.095 275.058 207.534 275.336 203.02C275.808 195.391 272.494 185.256 266.346 180.344Z",
    fill: "#EE9585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 193.799C269.669 194.665 269.495 195.632 268.875 195.958C268.256 196.284 267.425 195.846 267.019 194.98C266.613 194.114 266.787 193.147 267.407 192.821C268.027 192.494 268.858 192.933 269.263 193.799Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.611 197.93C260.017 198.796 259.843 199.763 259.223 200.089C258.603 200.416 257.772 199.977 257.367 199.111C256.961 198.245 257.135 197.278 257.754 196.952C258.374 196.626 259.205 197.064 259.611 197.93Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.443 197.911C265.865 196.07 264.203 194.326 262.517 192.588C262.354 192.419 262.071 192.631 262.225 192.819C263.479 194.341 264.738 195.837 266.061 197.303C266.7 198.012 267.506 198.737 267.845 199.651C268.13 200.416 267.818 201.167 267.399 201.802C267.29 201.967 267.413 202.219 267.627 202.178C268.366 202.039 268.771 201.22 268.742 200.519C268.7 199.514 268.072 198.645 267.443 197.911Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.756 184.604C268.816 183.304 264.667 184.971 264.465 186.571C264.202 188.652 271.374 186.838 269.756 184.604Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.108 191.113C253.87 189.703 249.277 192.05 249.213 193.936C249.102 197.212 256.627 192.843 255.108 191.113Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.801 205.398C261.867 204.962 265.595 204.637 266.02 205.068C266.29 205.343 265.626 206.946 264.029 207.045C262.711 207.126 261.726 205.905 261.801 205.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.905 186.698C247.598 192.492 248.436 205.691 243.941 204.119C239.446 202.548 237.832 202.607 237.832 202.607C222.261 187.389 233.562 174.933 243.905 186.698Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.643 188.201C247.934 179.62 252.389 178.149 262.052 182.639C264.907 183.965 272.721 183.684 273.133 180.418C273.404 178.27 270.852 177.605 270.852 177.605C275.862 176.134 273.691 171.517 269.786 173.674C276.261 168.185 271.202 163.725 267.068 167.262C263.883 169.988 261.357 171.142 256.846 169.955C250.132 168.19 238.627 171.191 237.707 182.293L244.643 188.201Z",
    fill: "#345870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.057 202.538L273.528 197.155C277.746 196.092 280.252 191.613 279.128 187.149C278.003 182.685 273.673 179.928 269.456 180.99L247.984 186.373C243.767 187.435 241.261 191.915 242.385 196.379C243.51 200.843 247.841 203.6 252.057 202.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.464 181.439C274.63 181.439 277.551 183.916 278.411 187.33C279.434 191.391 277.308 195.439 273.674 196.355L257.195 200.48C256.704 200.604 256.199 200.667 255.694 200.667C252.528 200.667 249.606 198.19 248.747 194.776C247.724 190.715 249.849 186.666 253.484 185.751L269.962 181.625C270.454 181.502 270.959 181.439 271.464 181.439ZM271.464 180.699C270.905 180.699 270.342 180.767 269.782 180.908L253.305 185.033C249.267 186.05 246.905 190.493 248.03 194.957C248.998 198.8 252.236 201.407 255.695 201.407C256.253 201.407 256.816 201.339 257.377 201.198L273.854 197.073C277.892 196.056 280.253 191.612 279.129 187.148C278.16 183.305 274.922 180.699 271.464 180.699Z",
    fill: "#5186C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.781 194.207L265.925 195.925L263.636 196.498L262.665 196.746L258.66 197.746L258.441 197.803C258.146 197.876 257.844 197.927 257.551 197.95C255.021 198.146 252.643 196.498 252.001 193.953C251.285 191.107 253.004 188.223 255.851 187.506L263.111 185.69L267.11 184.689L268.088 184.441L270.191 183.916C270.251 183.9 270.311 183.89 270.371 183.88C270.612 183.822 270.849 183.787 271.081 183.768C273.611 183.572 275.989 185.22 276.631 187.766C277.348 190.607 275.628 193.491 272.781 194.207Z",
    fill: "#D9DADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.535 183.75L262.413 197.642L257.799 198.796L262.927 184.903L267.535 183.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.294 182.816L266.171 196.696L263.534 197.356L268.662 183.463L271.086 182.859C271.155 182.84 271.225 182.829 271.294 182.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.467 190.355L259.551 193.33C258.823 193.512 258.086 193.069 257.904 192.34C257.722 191.612 258.165 190.875 258.893 190.692L270.808 187.717C271.537 187.535 272.274 187.979 272.456 188.707C272.638 189.435 272.196 190.174 271.467 190.355Z",
    fill: "#E47272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.397 214.289L241.221 215.998C238.515 216.891 235.597 215.423 234.703 212.716L232.579 206.286C231.686 203.579 233.154 200.661 235.861 199.767L241.036 198.058C243.742 197.165 246.66 198.633 247.554 201.34L249.678 207.77C250.573 210.476 249.103 213.395 246.397 214.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.402 202.731L237.989 202.538C239.761 201.952 241.671 202.915 242.257 204.687L243.43 208.239C244.015 210.011 243.053 211.922 241.282 212.508L240.696 212.701C238.924 213.287 237.013 212.325 236.428 210.553L235.255 207.001C234.669 205.227 235.63 203.316 237.402 202.731Z",
    fill: "#D9DADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.181 199.676C241.023 199.676 242.65 200.853 243.228 202.603L245.45 209.333C246.187 211.565 244.971 213.98 242.739 214.717L240.839 215.345C240.405 215.489 239.955 215.561 239.502 215.561C237.66 215.561 236.033 214.385 235.455 212.634L233.232 205.904C232.876 204.823 232.961 203.668 233.473 202.651C233.985 201.633 234.862 200.877 235.943 200.52L237.843 199.892C238.279 199.749 238.729 199.676 239.181 199.676ZM239.181 198.936C238.661 198.936 238.132 199.017 237.612 199.19L235.711 199.818C233.088 200.684 231.664 203.513 232.53 206.136L234.753 212.867C235.447 214.97 237.402 216.301 239.502 216.301C240.022 216.301 240.551 216.219 241.072 216.047L242.973 215.42C245.596 214.553 247.02 211.724 246.154 209.1L243.932 202.371C243.236 200.268 241.281 198.936 239.181 198.936Z",
    fill: "#5186C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2203_1589",
    x: 0,
    y: 0,
    width: 520,
    height: 373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2203_1589"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2203_1589",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2203_1589",
    x1: 81.5098,
    y1: 87.6013,
    x2: 111.235,
    y2: 130.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2203_1589",
    x1: 339.762,
    y1: 25.4322,
    x2: 355.919,
    y2: 59.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2203_1589",
    x1: 246.35,
    y1: 31.5367,
    x2: 266.824,
    y2: 126.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2203_1589",
    x1: 208.169,
    y1: 49.6208,
    x2: 249.476,
    y2: 49.6208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2203_1589",
    x1: 208.166,
    y1: 55.5414,
    x2: 249.419,
    y2: 55.5414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2203_1589",
    x1: 208.171,
    y1: 61.4615,
    x2: 249.378,
    y2: 61.4615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2203_1589",
    x1: 208.177,
    y1: 67.9231,
    x2: 223.986,
    y2: 67.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2203_1589",
    x1: 261.863,
    y1: 77.4872,
    x2: 303.17,
    y2: 77.4872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2203_1589",
    x1: 261.921,
    y1: 83.408,
    x2: 303.174,
    y2: 83.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2203_1589",
    x1: 261.961,
    y1: 89.3274,
    x2: 303.169,
    y2: 89.3274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2203_1589",
    x1: 287.353,
    y1: 95.7893,
    x2: 303.163,
    y2: 95.7893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2203_1589",
    x1: 326.729,
    y1: 129.742,
    x2: 403.495,
    y2: 129.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2203_1589",
    x1: 302.511,
    y1: 81.017,
    x2: 405.969,
    y2: 119.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2203_1589",
    x1: 300.03,
    y1: 87.7624,
    x2: 403.488,
    y2: 125.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2203_1589",
    x1: 297.549,
    y1: 94.5076,
    x2: 401.006,
    y2: 132.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2203_1589",
    x1: 295.067,
    y1: 101.253,
    x2: 398.525,
    y2: 139.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2203_1589",
    x1: 292.586,
    y1: 107.998,
    x2: 396.044,
    y2: 146.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2203_1589",
    x1: 290.104,
    y1: 114.744,
    x2: 393.562,
    y2: 152.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2203_1589",
    x1: 344.525,
    y1: 174.91,
    x2: 361.222,
    y2: 174.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2203_1589",
    x1: 344.626,
    y1: 173.057,
    x2: 361.222,
    y2: 173.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2203_1589",
    x1: 344.557,
    y1: 180.488,
    x2: 361.222,
    y2: 180.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2203_1589",
    x1: 114.568,
    y1: 103.829,
    x2: 191.335,
    y2: 103.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2203_1589",
    x1: 98.2046,
    y1: 97.3481,
    x2: 194.019,
    y2: 65.5834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2203_1589",
    x1: 100.492,
    y1: 104.248,
    x2: 196.307,
    y2: 72.4832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2203_1589",
    x1: 102.779,
    y1: 111.148,
    x2: 198.594,
    y2: 79.3832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2203_1589",
    x1: 105.067,
    y1: 118.047,
    x2: 200.882,
    y2: 86.2827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2203_1589",
    x1: 107.354,
    y1: 124.947,
    x2: 203.169,
    y2: 93.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2203_1589",
    x1: 109.642,
    y1: 131.848,
    x2: 205.457,
    y2: 100.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2203_1589",
    x1: 227.281,
    y1: 91.4383,
    x2: 213.722,
    y2: 101.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2203_1589",
    x1: 228.557,
    y1: 93.2449,
    x2: 214.999,
    y2: 102.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2203_1589",
    x1: 227.72,
    y1: 92.059,
    x2: 214.161,
    y2: 101.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2203_1589",
    x1: 228.996,
    y1: 93.8654,
    x2: 215.437,
    y2: 103.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2203_1589",
    x1: 228.159,
    y1: 92.6793,
    x2: 214.6,
    y2: 102.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2203_1589",
    x1: 229.434,
    y1: 94.4862,
    x2: 215.875,
    y2: 104.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2203_1589",
    x1: 228.597,
    y1: 93.2998,
    x2: 215.037,
    y2: 102.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2203_1589",
    x1: 120.389,
    y1: 187.031,
    x2: 151.03,
    y2: 200.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2203_1589",
    x1: 115.994,
    y1: 190.085,
    x2: 142.607,
    y2: 191.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2203_1589",
    x1: 115.637,
    y1: 196.247,
    x2: 142.251,
    y2: 197.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#A2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B4D2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#D2E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF4FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArvrDev);
export default __webpack_public_path__ + "static/media/arvr-dev.c8045f0c37ca44a16a014c156ba50149.svg";
export { ForwardRef as ReactComponent };